import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    title: 'Kit Inicio Profesional',
    value: '12€',
    items: ['Bio lista', 'Identidad profesional', 'Checklist inicio']
  }, {
    title: 'Guiones WhatsApp',
    value: '12€',
    items: ['+12 guiones listos', 'Respuestas rápidas', 'Situaciones difíciles']
  }, {
    title: 'Plan 7 Días',
    value: '12€',
    items: ['Tareas diarias', 'Checklist', 'Seguimiento avance']
  }];
  return <Section data-id="element-40">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-3 text-brand-primary" data-id="element-41">
        🎁 3 BONOS GRATIS
      </h2>
      <p className="font-body text-center text-brand-textMuted mb-6 text-sm" data-id="element-42">
        Valor 36€ · Incluidos sin coste
      </p>

      <div className="grid md:grid-cols-3 gap-4 max-w-5xl mx-auto" data-id="element-43">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-border rounded-lg p-4 shadow-sm" data-id="element-44">
            <div className="flex items-start justify-between mb-3" data-id="element-45">
              <h3 className="font-heading text-base font-bold text-brand-primary flex-1" data-id="element-46">
                {bonus.title}
              </h3>
              <div className="text-right" data-id="element-47">
                <div className="text-brand-textMuted text-xs line-through" data-id="element-48">
                  {bonus.value}
                </div>
                <div className="text-green-600 font-body font-bold text-sm" data-id="element-49">
                  GRATIS
                </div>
              </div>
            </div>

            <ul className="space-y-1" data-id="element-50">
              {bonus.items.map((item, j) => <li key={j} className="flex items-start gap-2" data-id="element-51">
                  <span className="text-green-500 shrink-0 text-sm" data-id="element-52">✓</span>
                  <span className="font-body text-brand-text text-xs" data-id="element-53">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>)}
      </div>
    </Section>;
}